import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { IBaseModel } from '../models/base.model';
import { ICustoEquipePlanejamentoModel } from '../models/custo-equipe-planejamento.model';
import { LocationStrategy } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CustoEquipePlanejamentoService extends BaseService {
  private readonly apiUrl = `${this.apiBaseUrl}/CustoEquipePlanejamento`;

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  obterPorPlanejamento(id: number, tipoTrabalho: string, secaoId?: number): Promise<IBaseModel<ICustoEquipePlanejamentoModel[]>> {
    const url = `${this.apiUrl}/${id}`;
    const parametroSessao = secaoId != null ? `/secao/${secaoId}` : '';
    return this.httpClient
      .get<IBaseModel<ICustoEquipePlanejamentoModel[]>>(url + parametroSessao)
      .toPromise();
  }

  obterPorId(id: number): Observable<IBaseModel<ICustoEquipePlanejamentoModel>> {
    return this.httpClient.get<IBaseModel<ICustoEquipePlanejamentoModel>>(`${this.apiUrl}/${id}`);
  }

  inserir(model: ICustoEquipePlanejamentoModel): Observable<IBaseModel<ICustoEquipePlanejamentoModel>> {
    return this.httpClient.post<IBaseModel<ICustoEquipePlanejamentoModel>>(this.apiUrl, model);
  }

  atualizar(model: ICustoEquipePlanejamentoModel): Observable<IBaseModel<ICustoEquipePlanejamentoModel>> {
    return this.httpClient.put<IBaseModel<ICustoEquipePlanejamentoModel>>(this.apiUrl, model);
  }

  excluir(id: number): Observable<IBaseModel<ICustoEquipePlanejamentoModel>> {
    return this.httpClient.delete<IBaseModel<ICustoEquipePlanejamentoModel>>(`${this.apiUrl}/${id}`);
  }
}
